
import { defineComponent, ToRefs } from 'vue';
export default defineComponent({
	name: 'fullscreen-image',

	props: {
		value: {
			type: Boolean,
			default: false
		},
		src: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			loading: true,
			error: false,
			width: 0,
			height: 0
		};
	},
	computed: {
		modelValue: {
			get(): boolean {
				return this.value;
			},
			set(value: boolean) {
				this.$emit('input', value);
			}
		},
		style() {
			if (!this.width || !this.height || this.loading || this.error) return {};
			const imgRatio = this.width / this.height;
			const screenRatio =
				document.documentElement.clientWidth / document.documentElement.clientHeight;
			if (imgRatio >= screenRatio) return { width: '100%' };
			return { height: '100%' };
		}
	},
	methods: {
		errorHandler() {
			this.loading = false;
			this.error = true;
		},
		hideHandler() {
			this.loading = true;
			this.error = false;
			this.width = this.height = 0;
		},
		onResize(size: { width: number; height: number }) {
			if (!size.height || !size.width || this.height || this.width) return;
			this.width = size.width;
			this.height = size.height;
		},
		clickOutside() {
			const dialog = this.$refs.dialog as ToRefs;
			dialog.hide();
		}
	}
});
